import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import store, { RootState } from '../../../../Redux/Store/store';
import getImagesNamesGroup from '../../../../utils/getImagesNameGroup';
import { AddSpriteToFramesAction } from '../../../../Redux/Actions/Animator/frames.list.action';
import generateId from '../../../../utils/generateId';
import { find, propEq, isEmpty } from 'ramda';

// Se usa para evitar el salto involuntario de una animación seleccionada
let click_selected = false;

const ImgList = () => {
    const images_list = useSelector((state: RootState) => state.imagesAtlas);
    const images_name = getImagesNamesGroup(images_list);
    const animation_list = useSelector((state: RootState) => state.AnimationList);
    const dispatch = useDispatch();

    // Buscamos por el frame activo en la caja de frames para mostrar la selección
    const actual_animation = find(
        propEq('id', animation_list.actual_animation),
        animation_list.animations
    );
    const active_frame = find(
        propEq('active', true),
        actual_animation !== undefined ? actual_animation.frames : []
    );

    // Obtenemos la posición del elemento para mover el scroll
    useEffect(() => {
        if (active_frame !== undefined && !isEmpty(active_frame) && click_selected) {
            const perfect_scroll = document.querySelector(
                '.perfect_scroll_imglist'
            ) as HTMLDivElement;
            const frame_position = document.querySelector(`#${active_frame.id}`) as HTMLDivElement;
            perfect_scroll.scrollTop = frame_position.offsetTop - 150;
        } else if (!click_selected) {
            click_selected = true;
        }
    });

    const html_element = images_name.map((name: string, key: any) => {
        return (
            <div className="animate_tool-container noselect" key={key}>
                <div className="text-color-primary mb-2">{name}</div>
                {images_list.reduce((prev: any, current: any, key: number) => {
                    if (current.name?.startsWith(name)) {
                        prev.push(
                            <div
                                className="ml-3"
                                key={key}
                                onClick={() => {
                                    const actual_animation = store.getState().AnimationList
                                        .actual_animation;
                                    if (actual_animation !== '0') {
                                        // Corrección de salto involuntario de animación.
                                        click_selected = false;
                                        dispatch(
                                            AddSpriteToFramesAction({
                                                id: actual_animation,
                                                sprite: {
                                                    id: current.id,
                                                    local_id: generateId('sprite'),
                                                    name: current.name,
                                                    src: current.src,
                                                    active: true,
                                                },
                                            })
                                        );
                                    }
                                }}
                            >
                                <div
                                    className={`animated bounceInRight card-image ${
                                        active_frame !== undefined &&
                                        active_frame.id === current.id &&
                                        'card-image-active'
                                    }`}
                                    id={current.id}
                                >
                                    <div className="card-image--image">
                                        <img
                                            src={current.src}
                                            alt={current.name}
                                            className="noselect"
                                        />
                                    </div>
                                    <div className="card-image--nameImage">{current.name}</div>
                                </div>
                            </div>
                        );
                    }
                    return prev;
                }, [])}
            </div>
        );
    });

    return <React.Fragment>{html_element}</React.Fragment>;
};

export default ImgList;
